var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.preloader)?_c('preloader',{attrs:{"margin":"30px"}}):_c('system-activity',{attrs:{"campaigns-id":[_vm.campaign.id],"date-range":_vm.dateRange,"timezone":_vm.timezone,"tab":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }